import { useEffect } from "react";

export function useLegacyRedirect() {
	useEffect(() => {
		if (window.location.hash.startsWith("#/")) {
			const legacyPath = window.location.hash.slice(2);
			window.location.replace(`/${legacyPath}`);
			return;
		}
	}, []);
}
